// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"signature_wrapper__2fgEm"};